export const protocol = process.env.REACT_APP_HTTP_PROTOCOL;
export const url = process.env.REACT_APP_API_URL;
